import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import './AdminReports.scss';
import { AdminReportsVM } from './AdminReportsVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';

export const AdminReports = observer(() => {
  const vm = useRef(new AdminReportsVM()).current;
  return (
    <div className="admin-content admin-reports-content">
      {vm.loading ? <Loader message={vm.loadingMessage}/> : null}
      <h1>Admin : Reports</h1>
      <div className="usa-card__container ml-0 reports-input-container">
        <div className="usa-card__header primary-card-header">
          <h2 tabIndex={0}>General Reports</h2>
        </div>

        <div className="reports-error-container">
          <h4 className="reports-header">All Net User</h4>    
            <div className={`reports-table-row user-list  ${vm.dateMethod === 'dateFilter' ? "list-bg": ""} `}>
              <div className="radio-allign">
                <div className="usa-radio">
                  <input
                    className="usa-radio__input"
                    id="quick-select"
                    type="radio"
                    name="date-method"
                    value='dateFilter'
                    checked={vm.dateMethod === 'dateFilter'}
                    onChange={vm.selectDateMethod}
                  />
                  <label className="usa-radio__label" htmlFor='quick-select'>Quick select</label>
                </div>

                <select
                  className="reports-select usa-select"
                  id="quick-select-options"
                  onChange={vm.selectRangeHandler}
                  disabled={vm.dateMethod !== 'dateFilter'}
                  aria-label='quick select options'
                  title='Quick select options'
                >
                  <option value="0">All time</option>
                  <option value="1">Last 7 days</option>
                  <option value="2">Last 30 days</option>
                  <option value="3">Last Quarter</option>
                  <option value="4">Current Quarter</option>
                  <option value="5">Month to Date</option>
                  <option value="6">Last 6 Months</option>
                  <option value="7">Last 12 Months</option>
                </select>
              </div>
            </div>
            <div className={`user-list ${vm.dateMethod === 'dateRange' ? "list-bg": ""} `}>
              <div className="radio-allign">
                <div className="usa-radio">
                  <input
                    className="usa-radio__input"
                    id="date-range"
                    type="radio"
                    name="date-method"
                    value='dateRange'
                    checked={vm.dateMethod === 'dateRange'}
                    onChange={vm.selectDateMethod}
                  />
                  <label className="usa-radio__label" htmlFor='date-range'>Select Date Range</label>
                </div>
                <div className="usa-date-picker">
                  <label htmlFor='starting-from-date' className='usa-label reports-select-second-label'>From</label>
                  <input
                    className={`usa-input reports-select-second ${vm.formValidation.startDate ? 'usa-input--error' : ''}`}
                    id="starting-from-date"
                    name="starting-from-date"
                    type="date"
                    aria-labelledby="starting-from-date-label"
                    max={vm.currentDateFormatted}
                    onChange={vm.setStartDate}
                    disabled={vm.dateMethod !== 'dateRange'}
                    // placeholder="DD/MM/YYY"
                  />
                  {/* <Icon path={mdiCalendarMonthOutline} size={1} /> */}
                  <label htmlFor='end-date' className='usa-label reports-select-third-label'>to</label>
                  <input
                    className={`usa-input reports-select-third ${vm.formValidation.startDate ? 'usa-input--error' : ''}`}
                    id="end-date"
                    name="end-date"
                    type="date"
                    aria-labelledby="end-date-label"
                    onChange={vm.setEndDate}
                    max={vm.currentDateFormatted}
                    disabled={vm.dateMethod !== 'dateRange'}
                    // placeholder="DD/MM/YYY"
                  />
                  {/* <Icon path={mdiCalendarMonthOutline} size={1} /> */}
                </div>
              </div>
            </div>
        </div>
        <button className="usa-button reports-button" onClick={vm.getCsvData} disabled={vm.formValidation.hasError}>
          Download as CSV
        </button>
      </div>
    </div>
  );
});
